import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AgGridModule } from 'ag-grid-angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { NgpTabset, NgpTabList, NgpTabButton } from 'ng-primitives/tabs';

import { SuiButtonComponent } from '@sui/button';
import { SuiButtonGroupComponent } from '@sui/button-group';
import { SuiComboboxComponent } from '@sui/combobox';
import {
  SuiMenuComponent,
  SuiMenuHeaderComponent,
  SuiMenuItemComponent,
  SuiMenuSeparatorComponent,
  SuiMenuTriggerDirective,
} from '@sui/menu';
import { SuiPaginationComponent } from '@sui/pagination';
import { SuiToolbarComponent } from '@sui/toolbar';
import { SuiTooltipDirective } from '@sui/tooltip';

import { LoadingComponent } from 'src/app/core/components/loading/loading.component';
import { DataGridComponent } from './components/data-grid/data-grid.component';
import { GridToolbarActionDirective } from './components/data-grid/grid-toolbar-action.directive';
import { GridDataViewComponent } from './components/data-grid/grid-data-view.component';
import { GridBulkActionsComponent } from './components/data-grid/grid-bulk-actions.component';
import { GridBulkScopeComponent } from './components/data-grid/grid-bulk-scope.component';
import { GridDetailPaneComponent } from './components/data-grid/grid-detail-pane.component';
import { GridToolbarComponent } from './components/grid-toolbar/grid-toolbar.component';

/**
 * The compositional grid stack (app-grid-toolbar + app-data-grid) in a module
 * with NO SharedModule dependency, so SharedModule itself can import and
 * re-export it, so grid views declared in SharedModule (user-editor dialog tabs)
 * compose app-data-grid without a module cycle. SensikaAgGridModule and
 * SharedModule both re-export it; feature modules get it through either.
 */
@NgModule({
  declarations: [
    GridToolbarComponent,
    DataGridComponent,
    GridToolbarActionDirective,
    GridDataViewComponent,
    GridBulkActionsComponent,
    GridBulkScopeComponent,
    GridDetailPaneComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AgGridModule,
    FontAwesomeModule,
    TranslateModule,
    NgpTabset,
    NgpTabList,
    NgpTabButton,
    LoadingComponent,
    SuiButtonComponent,
    SuiButtonGroupComponent,
    SuiComboboxComponent,
    SuiMenuComponent,
    SuiMenuHeaderComponent,
    SuiMenuItemComponent,
    SuiMenuSeparatorComponent,
    SuiMenuTriggerDirective,
    SuiPaginationComponent,
    SuiToolbarComponent,
    SuiTooltipDirective,
  ],
  exports: [
    GridToolbarComponent,
    DataGridComponent,
    GridToolbarActionDirective,
    GridDataViewComponent,
    GridBulkActionsComponent,
    GridBulkScopeComponent,
    GridDetailPaneComponent,
  ],
})
export class DataGridModule {}
